import { render, staticRenderFns } from "./InputModule.vue?vue&type=template&id=47e7c83a"
import script from "./InputModule.vue?vue&type=script&lang=js"
export * from "./InputModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./InputModule.vue?vue&type=style&index=0&id=47e7c83a&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports